module.exports = __webpack_public_path__ + "static/media/agenda-hover.cbf3375a.png";